module.exports = __webpack_public_path__ + "img/success_approval.svg";